import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ListComponent} from './list/list.component';
import { ListRoutingModule } from './list-routing.module';
import { EpguLibModule } from 'epgu-lib';

@NgModule({
  declarations: [
    ListComponent
  ],
  exports: [
    ListComponent
  ],
  imports: [
    CommonModule,
    ListRoutingModule,
    // HttpClientModule, // Ð·Ð°Ð²Ð¸ÑÐ¸Ð¼Ð¾ÑÑÑ Ð½ÑÐ¶Ð½Ð°Ñ ÑÐ¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ Ð¾ÑÐ»Ð°Ð´ÐºÐ¸ Ð¿ÑÐ¸ ÑÐ±Ð¾ÑÐºÐµ ÐµÐµ ÐÐ£ÐÐÐ ÐÐ¢ÐÐÐ®Ð§ÐÐ¢Ð¬!
    // BrowserAnimationsModule, // Ð·Ð°Ð²Ð¸ÑÐ¸Ð¼Ð¾ÑÑÑ Ð½ÑÐ¶Ð½Ð°Ñ ÑÐ¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ Ð¾ÑÐ»Ð°Ð´ÐºÐ¸ Ð¿ÑÐ¸ ÑÐ±Ð¾ÑÐºÐµ ÐµÐµ ÐÐ£ÐÐÐ ÐÐ¢ÐÐÐ®Ð§ÐÐ¢Ð¬!
    EpguLibModule.forRoot(),
  ]
})
export class ListModule {
}
